<template>
    <div class="page">
        <div class="page-top">
            <div class="user">
                <div class="user-img">
                    <img  src="@/assets/userNew/icon23.png" >
                </div>
                <div class="user-name">
                    <div class="user-name-top">{{ this.$store.state.recordLoginText }}</div>
                    <div class="user-name-bt">套餐有效期至：{{simInfo.endTimeString }}</div>
                </div>
            </div>
            <div class="flow">
                <div class="flow-items">
                    <div class="flow-num">{{simInfo.pkgName  }}</div>
                    <div class="flow-name">在用套餐</div>
                </div>

                <div class="flow-items">
                    <div class="flow-num">{{fluxMtoG(simInfo.surplusFlowRate || 0)}}<span>G</span></div>
                    <div class="flow-name">套餐剩余流量</div>
                </div>
               
                <div class="flow-items">
                    <div class="flow-num">{{  money_format(userSimAmount / 100, 2, ".", ",") * 1 }}<span>元</span></div>
                    <div class="flow-name">账号余额</div>
                </div>
                
            </div>
        </div>
        <div class="vant-tabs">
            <div class="vant-tab-panl" :class="{'vant-tab-active':tabbar==1}" @click="tabbarClick('1')">基础套餐</div>
            <div class="vant-tab-panl" :class="{'vant-tab-active1':tabbar==2}" @click="tabbarClick('2')">加油套餐</div>
        </div>
        <div class="recharge-list">
            <div class="recharge-list-items" :class="{'recharge-list-items-active' : indexActive === item.id ,'recharge-list-items-disabled':item.limitState === 1}"  v-for="item in simData" :key="item.id" @click="changeState(item,'1')" v-show="tabbar==1">
                <div class="recharge-list-items-left">
                    <div class="top">{{ item.packageName }}</div>
                    <div v-if="item.remark" class="meddle">{{item.remark}}</div>
                    <p v-if="item.dayRemarkInfo" class="meddle" style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                    <p v-if="item.dayRemarkInfo" class="meddle">{{item.dayRemarkInfo}}</p>
                    <div v-if="item.dayRemarkInfo"  class="meddle"></div>
                    <div  class="meddle"></div>

                </div>
                <div class="recharge-list-items-right">
                    <!-- <div v-if="item.salePriceRmb - ( toatl ? toatl : 0) > 0">¥{{money_format(item.salePriceRmb - ( toatl ? toatl : 0), 2, '.', ',') }}元</div> -->
                    <div v-if="item.salePriceRmb - ( toatl ? toatl : 0) > 0">¥{{(item.salePriceRmb - ( toatl ? toatl : 0)).toFixed(2) }}元</div>
                    <div v-else>¥ 0 元</div>
                    <div style="font-size: 12px;font-weight: normal;text-decoration:line-through;" v-if="toatl > 0">原价{{item.salePriceRmb }}</div>
                </div>
                <div class="title" v-if="item.titleRemark">{{ item.titleRemark }}</div>
                <div class="dis-btn" v-if="item.limitState === 1" @click="clickDeblock(item.limitRemark)">点击解锁</div>
            </div>
            <div class="recharge-list-items  " v-for="item in simData2" :key="item.id" @click="changeState(item, 2)" v-show="tabbar==2" :class="{'recharge-list-items-active':indexActive2 === item.id,'recharge-list-items-disabled':item.limitState === 1}">
                <div class="recharge-list-items-left">
                    <div class="top">{{ item.packageName }}</div>
                    <div class="meddle">{{item.remark}}</div>
                    <div class="bottom">{{item.redRemark}}</div>
                </div>
                <div class="recharge-list-items-right">
                    <div>￥{{item.salePriceRmb}}元</div>
                    <!-- <div style="font-size: 12px;font-weight: normal;text-decoration:line-through;">原价{{item.salePriceRmb - ( toatl ? toatl : 0) }}</div> -->
                </div>
                <div class="title" v-if="item.titleRemark">{{ item.titleRemark }}</div>
                <div class="dis-btn" v-if="item.limitState === 1" @click="clickDeblock(item.limitRemark)">点击解锁</div>
            </div>
        </div>

        <!--footer-->
        <div class="footer">
            <p class="detail" v-if="isNaturalMonth && thisCucc==1" style="color: #FF6463;">每月22号后 请优先选择次月生效</p>
			<p class="detail" v-else-if="isNaturalMonth && isShowdetail">每月25号后 请优先选择次月生效</p>
            <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
                <van-radio-group v-model="isNextMonth" class="radio-group-defined">
                    <div>
                        <van-radio name="0" checked-color="#FF6463">本月生效</van-radio>
                    </div>
                    <div>
                        <van-radio name="1" checked-color="#FF6463">次月生效</van-radio>
                    </div>
                </van-radio-group>
            </div>
            <div class="footer-payment">
                <div class="footer-monery" v-if="showjuan">
                    <div class="total">合计：</div>
                    <div class="total-num">
                        ¥{{ price - toatl > 0 ? (price - toatl).toFixed(2) : 0 }}元
                        <span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠 ¥{{ toatl }}</span>
                    </div>
                </div>
                <div class="footer-monery" v-else>
                    <div class="total">合计：</div>
                    <div class="total-num">
                        ¥{{price}}元
                        <span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠 ¥ 0</span>
                    </div>
                </div>
                <div class="clock-sumbit" @click="toRechange()" v-if="limitState !== 1" >订购 </div>
                <div class="clock-sumbit toRechargeBtn1" v-else>订 购</div>
            </div>
        </div>

        <van-dialog
            v-model="helpShow"
            title="点击解锁"
            :show-confirm-button="false"
            >
            <div class="dialog-text">{{ limitRemark }}</div>
            <div class="btn-vis">
                <van-button type="primary"  class="dialog-btn2" @click="closrDialog">取消</van-button>
                <van-button type="primary"  class="dialog-btn3" @click="toBalanceRecharge">购买余额</van-button>
            </div>
        </van-dialog>
        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
            :yuPrice="yuPrice"
            :yr="yr"
            :typeStyle="typeStyle"
        />
    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { Dialog } from 'vant';
import Checkstand from "@/components/Checkstand";
export default {
    components: {Checkstand},
    data(){
        return {
            userSimAmount:localStorage.getItem('userSimAmount'),
            shebeiLogin: localStorage.getItem("shebeiLogin"),
            indexActive: '',
            showjuan: true,//是否展示优惠卷
            toatl: 0,
            simData: [],
			simInfo:{},
            nu:0,
            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
            secondaryId: '',
            primaryId: '',
            isAdmin: '',
            globalIsAdmin: '',
			wxHeadImg: localStorage.getItem('wxHeadImg'),
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price:0,
            typeStyle: 1, //流量充值入口为1
            tabbar: 1,

            simData2: [],
            indexActive2: '',
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            },
            result:{},
            helpShow:false,
            isShowdetail:false,
            thisCucc:0,
            yr:0,
            yuPrice:false,
            amountObj:{},
            limitRemark:'',
            limitState:''
        }
    },
    mounted(){
        wxRequest("sim/get/amount", {iccid: this.$store.state.iccid,}, "post").then(res=>{
            this.amountObj = res.data
        })
    },
    created(){
        wxRequest("sim/detail", { iccid: this.$store.state.iccid	}, "post").then(res => {
            if (res.data.code === '200') {
                this.simInfo =  res.data.data;
            }
        })
        wxRequest("sim/user/soldPkg",  { iccid: this.$store.state.iccid	}, "get").then(res => {
            var result = res.data.data;
            this.result = res.data.data;
            if(res.data.code === '200' && result.list.length > 0){
                let resultArray1 = [];
                let resultArray2 = [];
                for(let i=0; i<result.list.length; i++){
                     console.log('当前type'+result.list[i].type);
                    if(result.list[i].type == 17||result.list[i].type == 14){
                        this.thisCucc=1
                    }
                    if(result.list[i].type == 1 || result.list[i].type == 4  || result.list[i].type == 5 || result.list[i].type == 11 || result.list[i].type == 13 || result.list[i].type == 16 ||result.list[i].type == 18 ||result.list[i].type == 19){
                        this.simData2.push(result.list[i])
                        this.simData2.sort((b, a) => b.sort - a.sort);
                    }else {
                        if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                            if(!result.endTime){
                                resultArray2.push(result.list[i])
                            }
                        }else {
                            resultArray1.unshift(result.list[i])
                        }
                    }
                }
                 /**每月倒数第6天默认选中次月生效**/
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                console.log('当前日期'+day);
                console.log('当前cucc'+this.thisCucc);
                var date2 = new Date(year, month + 1, 0)
                var endDay = date2.getDate();
                if(this.thisCucc==0){
                    day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
                }else{
                    if(day >=21 && day <=26){
                        this.isNextMonth ='1'
                    }else{
                        this.isNextMonth= '0'
                    }
                }
                this.simData = resultArray1.concat(resultArray2);
                this.simData.sort((b, a) => b.sort - a.sort);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14|| this.simData[0].type == 6
                || this.simData[0].type == 25 || this.simData[0].type == 17? true : false; 
                this.isShowdetail=  this.simData[0].type == 2 ||  this.simData[0].type == 10? true : false; 
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
                this.limitState = this.simData[0].limitState
                this.toatl = 0
                this.secondaryId = ''
                this.primaryId = ''
                if (this.$route.query.total) {
                    this.toatl = this.$route.query.total * 1 || 0
                    this.secondaryId = this.$route.query.secondaryId
                    this.primaryId = this.$route.query.primaryId
                }else{
                    this.toatl = result.subJuan.price * 1 || 0
                    if(result.subJuan.types === 1){
                        this.secondaryId = result.subJuan.id
                    }else{
                        this.primaryId = result.subJuan.id
                    }
                }
                
            }
        })
    },
    methods:{
        //点击tabbar
        tabbarClick(index){
            this.tabbar = index;
            this.showjuan = !this.showjuan
            if(this.simData.length != 0 && index == '1'){
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
                if (this.$route.query.total) {
                    this.toatl = this.$route.query.total * 1  || 0
                    this.secondaryId = this.$route.query.secondaryId
                    this.primaryId = this.$route.query.primaryId
                }else{
                    console.log(this.result)
                    this.toatl = this.result.subJuan.price * 1 || 0
                    if(this.result.subJuan.types === 1){
                        this.secondaryId = this.result.subJuan.id
                    }else{
                        this.primaryId = this.result.subJuan.id
                    }
                }
				this.changeState(this.itemInfo,index)
            }else if(this.simData2.length != 0 && index == '2'){
                this.indexActive2 = this.simData2[0].id;
                this.price = this.simData2[0].salePriceRmb;
                this.itemInfo2 = this.simData2[0];
                this.toatl = 0
                this.secondaryId = ''
                this.primaryId = ''
				this.changeState(this.itemInfo2,index)
            }
        },
        clickDeblock(data){
            this.limitRemark = data
            this.helpShow = true
        },
        closrDialog(){
            this.helpShow = false
        },
        toBalanceRecharge() {
            let fd = new FormData();
            fd.append("supplierId", sessionStorage.getItem("supplierCode"));
            wxRequest("sim/invent/state", fd, "post").then((res) => {
                if (res.data.code == 200) {
                    this.$router.push({
                        path: "/user/balanceRecharge",
                        query: {
                        iccid: this.$store.state.iccid,
                    },
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        lintTo() {
            this.$router.push({ name: 'userNewCoupon' })
        },
        changeState(item, tabbar){
            this.limitState = item.limitState
            if(tabbar == 1){
                this.indexActive = item.id;
                this.itemInfo = item; 
                this.price = item.salePriceRmb;
            }else {
                this.indexActive2 = item.id;
                this.itemInfo2 = item; 
                this.price = item.salePriceRmb;
            }
            if(item.isAdmin!=null && item.isAdmin!=undefined && item.isAdmin==1){
                this.isAdmin = item.isAdmin;
            }else{
                this.isAdmin = this.globalIsAdmin;
            }
            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.showMonthChoose = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.isShowdetail= item.type == 2 || item.type == 10? true : false; 
        },
        toRechange(){
            this.showCheckstand=false;
            var pop = {                
                iccid: this.$store.state.iccid,
                pkgId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                isNextMonth: this.isNextMonth
            }
              //判断是否是月卡
            if(this.isNaturalMonth||this.showMonthChoose==true){
                pop.isNextMonth = this.isNextMonth;
            }else{
                pop.isNextMonth = '0';//万能卡
            }
            if(this.tabbar == 1){
                pop.pkgId=this.itemInfo.id
            }else{
                pop.pkgId=this.itemInfo2.id
            }
            wxRequest("sim/activity/timer",pop, "post").then(res => {
                var dataObj={
                    iccid: this.$store.state.iccid,
                    isAdmin: this.isAdmin,
                    secondaryId: this.secondaryId,
                    primaryId: this.primaryId,
                    toatl: this.toatl,
                    mobile: this.mobile,
                    isNextMonth:this.isNextMonth?this.isNextMonth:'0',
                    source:this.$store.state.source ? this.$store.state.source : 'xxgzh'
                }
                if(this.tabbar == 1){
                    this.dataToPay = {
                        ...dataObj,
                        soldPackageId:this.itemInfo.id,
                        salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1 ,2, '.', ','): 0,
                    };
                }else {
                    this.dataToPay = {
                        ...dataObj,
                        soldPackageId:this.itemInfo2.id,
                        salePriceRmb: this.itemInfo2.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo2.salePriceRmb - this.toatl * 1 ,2, '.', ','): 0,
                    };
                }
                if(res.data.code === '200'){
                    Dialog.confirm({
                        title: "套餐生效提醒",
                        message: "生效时间："+res.data.data.start  +"<br/>到期时间："+res.data.data.end+"<br/>谨慎订购，误订不退款"
                    }) .then(() => {
                        this.$store.state.showCheckstand = true;
                        this.$store.state.showCheckstandSource = 'flowRecharge';
                        
                    }).catch(() => {});
                }else{
                    this.$store.state.showCheckstand = true;
                    this.$store.state.showCheckstandSource = 'flowRecharge';
                }
                var zPrice= 0
                if(this.tabbar == 1){
                    zPrice= this.money_format(this.price, 2, ".", ",") - dataObj.toatl > 0 ? this.money_format(this.money_format(this.price, 2, ".", ",") - dataObj.toatl) : 0
                }else {
                    zPrice= this.money_format(this.price, 2, ".", ",") - dataObj.toatl > 0 ? this.money_format(this.money_format(this.price, 2, ".", ",") - dataObj.toatl) : 0
                }
                if(this.amountObj.code === '200'){
                    this.yr = this.amountObj.data
                    if(this.amountObj.data < zPrice * 1){
                        this.yuPrice = false
                    }else{
                        this.yuPrice = true
                    }
                }else{
                    this.yuPrice = true
                }
                console.log(this.yuPrice)
            })
        },
    }
}
</script>
<style scoped lang="less">
.page{
    padding-bottom:150px;
    overflow: auto;
    background: #F7F8FA;
    height:calc(100vh - 150px);
    .page-top{
        width:93.5%;
        margin:14px auto;
        background: url('../../assets//userNew/icon22.png') no-repeat center;
        background-size: 100% 100%;
        height:172px;
        .user{
            display: flex;
            align-items: center;
            .user-img{
                width:50px;
                height:50px;
                margin-top:15px;
                margin-left: 22px;
                border-radius:100%;
                img{
                    width:100%;
                    height:100%;
                    border-radius:100%;
                }
            }
            .user-name{
                margin-left:10px;
                margin-top:20px;
                .user-name-top{
                    height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #6B4A15;
                    line-height: 22px;
                }
                .user-name-bt{
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #BB975D;
                    line-height: 17px;
                }
            }
        }
        .flow{
            display: flex;
            justify-content: space-between;
            margin:0 14px;
            margin-top:40px;
            .flow-items{
                text-align: center;
                .flow-num{
                    height: 22px;
                    font-size: 15px;
                    font-family: HarmonyOS_Sans_SC_Bold;
                    color: #6B4A15;
                    line-height: 22px;
                    span{
                        font-size: 12px;
                        font-family:HarmonyOS Sans SC ;
                    }
                }
                .flow-name{
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #BB975D;
                    line-height: 17px;
                }
            }
        }
    }
    .vant-tabs{
        width:93.5%;
        margin:0 auto;
        height:46px;  
        background: #ECEFF4;
        border-radius: 10px 10px 0px 0;
        display: flex;
        align-items: center;
        .vant-tab-panl{
            flex: 1;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #050505;
            font-weight: bold;
            line-height: 46px;
            height:100%;
        }
        .vant-tab-active{
            background:url('../../assets/userNew/icon25.png') no-repeat center top;
            background-size:100% 100%;
            height:54px;
            line-height: 54px;
            position: relative;
            top:-4px;
        }
        .vant-tab-active1{
            background:url('../../assets/userNew/icon57.png') no-repeat center top;
            background-size:100% 100%;
            height:54px;
            line-height: 54px;
            position: relative;
            top:-4px;
        }
    }
    .recharge-list{
        width:93.5%;
        margin:0 auto;
        background:#fff;
        padding:18px 0;
        .recharge-list-items{
            margin: 0 10px;
            margin-bottom:20px;
            border-radius: 8px;
            position: relative;
            display: flex;
            width: calc(100% - 40px);
            padding:14px 10px;
            border: 1px solid #C5C6C8;
            .title{
                position: absolute;
               /* // width:116px; */
                height: 24px;
                background: url('../../assets/userNew/icon24.png') no-repeat center;
                background-size:100%;
                color: #fff;
                text-align: center;
                line-height:24px;
                left:0;
                font-size: 12px;
                top:-12px;
            }
            .recharge-list-items-left{
                width:77%;
                margin-right:5px;
                .top{
                    min-height: 25px;
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #28292D;
                    line-height: 25px;
                }
                .meddle{
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #63666D;
                    line-height: 17px;
                }
                .bottom{
                    height: 17px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #F80200;
                    line-height: 17px;
                }
            }
            .recharge-list-items-right{
                height: 23px;
                font-size: 12px;
                font-family: HarmonyOS_Sans_SC_Bold;
                color: #F89E20;
                line-height: 23px;
                font-weight: bold;
            }
        }
        .recharge-list-items-active{
            border: 1px solid #397EF5;
            background: #EFF5FF;
        }
        .recharge-list-items-disabled{
            background: #C5C6C8;
        }
        .dis-btn{
            position: absolute;
            width: 78px;
            height: 30px;
            background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
            border-radius: 15px;
            font-size: 14px;
            font-family: HarmonyOS_Sans_SC;
            color: #FFFFFF;
            line-height: 30px;
            left:0;
            right:0;
            top:0;
            bottom:0;
            margin: auto;
            text-align: center;
        }
    }
    .footer{
        position: fixed;
        width:100%;
        bottom:0;
        background: #fff;
        .quan {
            background: #F6F6F6;
            display: flex;
            align-items: center;
            height: 46px;
            div {
                width: 50%;
            }

            .w-zh {
                color: #28292D;
                font-size: 18px;
                padding-left: 20px;
                line-height:52px;
                font-weight: 600;
                height: 100%;
            }

            .z-icon {
                text-align: right;
                background: url('../../assets/userNew/arrow.png')no-repeat 90% center;
                padding-right: 36px;
                color: #DE4160;
                font-weight: 600;
                font-size: 14px;
                height: 100%;
                line-height:46px;
            }
        }
        .toRecharge-top{
            display: flex;
            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
                height: 34px;
				/deep/.van-radio__icon--checked{
					.van-icon-success{
						background-color: #24BAC8 !important;
						border-color: #24BAC8 !important;
					}
				}
				/deep/.van-radio__label{
					color:#666;
					margin-left:0px
				}
                div{
                    height: 20px;
                    margin-right: 15px;
					.van-icon{
						font-size:12px;
					}
					&.van-radio__icon {
						margin-right: 0;
					}
                }
				span{
					font-size:0.75rem;
				}
            }

        }
        .detail {
            color: #96989D;
			font-size: 12px;
            padding-left: 20px;
            padding-top: 5px;
        }
        .footer-payment{
            display: flex;
            justify-content: space-between;
            width:100%;
            bottom:0;
            border-top: 1px solid #eee;
            height: 52px;
            align-items: center;
        }
        .footer-monery{
            width: calc(100% - 127px);
            display: flex;
            margin-left:16px;
            .total{
                width: 42px;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #28292D;
                line-height: 20px;
            }
            .total-num{
                height: 23px;
                font-size: 16px;
                font-family: HarmonyOS_Sans_SC_Bold;
                color: #F89E20;
                line-height: 23px;
            }
        }
        .clock-sumbit{
            text-align: center;
            background:#429BFF;
            color:#fff;
            font-size: 16px;
            height:52px;
            line-height:52px;
            width:127px;
        }
    }
}
.van-dialog{
    background:url('../../assets/userNew/iconBg.png') no-repeat center;
    width:290px;
    height:247px;
    background-size: 100%;
    ::v-deep .van-dialog__header{
        margin-top:70px;
        color: #222;
        font-weight: 600;
        font-size:19px;
    }
    .dialog-text{
        color: #94959A;
        font-size:15px;
        padding-top:11px;
        text-align: center;
        padding-bottom:34px;
    }
    .btn-vis {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width:90%;
        margin: auto;
        .dialog-btn2 {
            width: 120px;
            height: 47px;
            color: #666666;
            text-align: center;
            background: #F5F5F5 !important;
            border: 0 !important;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
        }
        .dialog-btn3 {
            width: 130px;
            height: 47px;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
            border: 0;
            color: #fff;
            background: linear-gradient(90deg, #FFA451 0%, #FF6140 100%);
            margin-left: 10px;
            text-align: center;
        }
    }
}
.toRechargeBtn1{
    color:#000 !important;
    background: #ccc !important;
}
</style>